import React, { useState } from 'react';
import { Image, Modal, ModalBody, Icon, ModalFooter, XLineIcon } from '@/components';
import { FacebookShareButton } from 'react-share';
import { useOpenBoxLucky } from '../../api';
import { LuckyModel } from '@/models/lucky';
import toast from 'react-hot-toast';
import { LuckyDetail } from '../../const';
import { CountDown } from './countdown';
import { parseUtcTime } from '@/libs/app';
type LuckyProps = {
  lucky: LuckyDetail;
  callRefetch: () => void;
};
export const LuckyPartial = ({ lucky, callRefetch }: LuckyProps) => {
  const [dataOpenLucky, setData] = useState<LuckyModel | null>(null);
  // const [isCountdown, setShowCountDown] = useState<boolean>(isShow);
  const { mutate } = useOpenBoxLucky({
    onError: ({ message }) => {
      toast.error(message);
    },
    onSuccess: ({ data }) => {
      if (data.id) {
        setData(data);
        callRefetch();
      }
    },
  });
  let isCountdown =
    !!lucky?.time_can_open_next_box && new Date(lucky?.time_can_open_next_box).getTime() > parseUtcTime();
  return (
    <>
      <div
        className="tw-flex tw-justify-center tw-flex-col tw-items-center tw-cursor-pointer tw-relative"
        onClick={() => !isCountdown && mutate(lucky?.id)}
      >
        <Image
          className="tw-w-10 tw-h-10"
          src={isCountdown ? '/gift-f.gif' : '/icons8-gift.gif'}
          alt="lucky gif"
        ></Image>
        <div className="tw-border tw-border-white tw-rounded-5 tw-px-2 tw-flex tw-justify-center tw-items-center">
          <Image objectFit="contain" className="tw-w-16 tw-h-5" src="/luck.png" alt="luck"></Image>
        </div>
        {isCountdown && (
          <>
            <span
              className="tw-text-white tw-text-xs tw-px-2 tw-bg-black tw-bg-opacity-70 tw-absolute tw-z-10 tw--bottom-7"
              style={{
                borderRadius: '3px',
                paddingTop: '2px',
                paddingBottom: '2px',
              }}
            >
              {lucky && lucky?.time_can_open_next_box && (
                <CountDown endTime={lucky?.time_can_open_next_box} handleCountDown={() => callRefetch()} />
              )}
            </span>
            {/* <div className="tw-absolute tw-left-0 tw-bottom-0 tw-bg-black tw-bg-opacity-50 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center"></div> */}
          </>
        )}
      </div>
      {dataOpenLucky && (
        <Modal className="tw-p-0 tw-relative !tw-bg-transparent !tw-max-w-xl">
          <ModalBody className="tw-p-0 tw-relative tw-h-96 md:tw-h-164 tw-w-full">
            <div
              className="tw-flex tw-justify-center tw-items-center tw-w-11 tw-h-11 tw-absolute tw--right-5 tw--top-5 tw-rounded-full tw-border tw-border-red-500 tw-z-50 tw-cursor-pointer"
              onClick={() => setData(null)}
            >
              <div className="tw-flex tw-w-9 tw-h-9 tw-rounded-full tw-p-2 tw-bg-white tw-items-center tw-justify-center tw-text-red-500">
                <Icon className="tw-w-full tw-h-full" icon={<XLineIcon />}></Icon>
              </div>
            </div>
            <Image
              className="tw-w-full tw-h-full tw-rounded-10 tw-overflow-hidden"
              src={dataOpenLucky?.attachment_url}
              alt="bg-lx"
              objectFit="cover"
            ></Image>
          </ModalBody>
          <ModalFooter>
            <FacebookShareButton className="tw-w-full" url={dataOpenLucky?.attachment_url || ''}>
              <div className="tw-w-full tw-py-2 tw-rounded-5 tw-bg-white tw-border-white !tw-text-secondary-70">
                Chia sẻ
              </div>
            </FacebookShareButton>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};
